import FirecrawlApp, { ScrapeResponse } from '@mendable/firecrawl-js';
import { ScrapResult } from './types';

let app: FirecrawlApp | null = null;

async function scrape(url: string): Promise<ScrapResult> {

  try {
    app = app || new FirecrawlApp({ apiKey: localStorage.getItem('FIRECRAWL_API_KEY') }) || '';

    const scrapeResponse = await app.scrapeUrl(url, { formats: ['markdown', 'html'] }) as ScrapeResponse;

    if (!scrapeResponse.success) {
      console.log(scrapeResponse.error || 'Failed to scrape the content from the URL:' + url);
      return ScrapResult.withError(scrapeResponse.error || 'Failed to scrape the content from the URL:' + url);
    }

    if (!scrapeResponse.markdown && !scrapeResponse.html) {
      console.log('No content found in the URL:', url);
      return ScrapResult.withError('No content found in the URL:' + url);
    }

    if (!scrapeResponse.metadata?.title || scrapeResponse.metadata?.title === '') {
      scrapeResponse.metadata!.title = 'Untitled';
    }

    return ScrapResult.withSuccess(scrapeResponse.markdown || '', scrapeResponse.html || '', scrapeResponse.metadata?.title || '');
  } 
  catch (error) {
    console.log(`Firecrawl error: ${error}`);
    return ScrapResult.withError(`Firecrawl error: ${error}`);
  }
}

export default scrape